<template>
	<div class="c-object-listing">
		<v-object-listing-data-provider :object-type="objectType" :api-url="apiUrl" :default-image-url="defaultImageUrl">
			<div class="o-grid" slot-scope="dataProvider">
				<div class="c-object-listing__filters o-grid__column" data-size="sm:12" v-if="enableFilters">
					<v-filters-wrapper
						:objects="dataProvider.currentObjects"
						:multi-select-filters="dataProvider.multiSelectFilters"
						@setMultiSelectFilter="dataProvider.setMultiSelectFilter"
						:range-filters="dataProvider.rangeFilters"
						@setRangeFilter="dataProvider.setRangeFilter"
						@resetAllFilters="dataProvider.resetAllFilters"
						:filters-applied="dataProvider.filtersApplied"
						:reset-all-text="resetAllText"></v-filters-wrapper>
				</div>
				<div class="c-object-listing__utilities o-grid__column" data-size="sm:12" data-layout="" id="utilities">
					<div>
						<p v-if="!dataProvider.isLoading" class="t-text-style-epsilon t-margin--2-bottom" role="status">
							<span class="header-border">
								Visar <span class="t-text-color--emphasis">{{dataProvider.currentObjects.length}}</span> {{objectTypeDisplay}}
							</span>
						</p>

						<a href="#" class="t-reset-link" @click.prevent="dataProvider.resetAllFilters" v-if="dataProvider.filtersApplied && dataProvider.currentObjects.length === 0">
							{{resetAllText}}
						</a>
					</div>
					{{dataProvider.sortOption}}
					<div v-if="enableSorting">
						<v-select
							label="Sortera efter"
							icon-at-small= "icon-order"
							id="sortObjectList"
							:visible-label="true"
							:selected='0'
							:options="options"
							@optionSelected="dataProvider.setSortOption">
						</v-select>
					</div>
				</div>
				<div class="c-loading o-grid__column" data-size="sm:12" v-if="dataProvider.isLoading">
					<div class="c-loading__circle">
					</div>
					<span class="c-loading__text">{{loadingText}}</span>
				</div>
				<div class="o-grid__column" data-size="sm:12">
					<div class="c-object-listing__grid" v-if="!dataProvider.isLoading">
						<div
							v-for="(object, index) in dataProvider.currentObjects"
							:key="index"
							:data-size="object.isHighlighted ? 'sm:12' : 'sm:6 md:4'">
								<v-object
									:url="object.url"
									:title="object.title"
									:image="object.imageUrl"
									:published="object.publishedDate"
									:access="object.rentalStart"
									:byline="object.district"
									:text="object.description"
									:address="object.address"
									:pros="object.featuresAsString"
									:info="object.facts"
									:buttons="object.buttons"
									:variant="object.isHighlighted"
									:object-type="object.objectType">
								</v-object>
						</div>
					</div>
				</div>
			</div>
		</v-object-listing-data-provider>
	</div>
</template>

<script>
import VSelect from '../../../components/form-elements/select/VSelect.vue';
import VIcon from '../../../components/icon/VIcon.vue';
import VFiltersWrapper from '../../../components/filters-wrapper/VFiltersWrapper.vue';
import VObject from '../../../components/object-listing/object/VObject.vue';
import VObjectListingDataProvider from '../../../components/object-listing/object-listing-data-provider/VObjectListingDataProvider.vue';

export default {
	name: 'VObjectListing',
	components: {
		VObject,
		VObjectListingDataProvider,
		VSelect,
		VIcon,
		VFiltersWrapper
	},
	props: {
		enableSorting: {
			type: Boolean,
			default: false
		},
		enableFilters: {
			type: Boolean,
			default: false
		},
		apiUrl: {
			type: String,
			default: ''
		},
		objectType: {
			type: String,
			default: ''
		},
		options: {
			type: Array,
			default: () => [
				{
					value: 'publishedDate',
					display: 'Publiceringsdatum'
				},
				{
					value: 'rentalStart',
					display: 'Tillträde'
				},
				{
					value: 'address',
					display: 'Adress'
				}
			]
		},
		resetAllText: {
			type: String,
			default: 'Återställ val'
		},
		loadingText: {
			type: String,
			default: 'Laddar objekt'
		},
		defaultImageUrl: {
			type: String,
		},
	},
//	created(){
//		console.log("Object listing", this.apiUrl, this.objectType, this.$store)
//
//		this.$store.dispatch('objects/fetchObjects', {
//			objectType: this.objectType,
//			apiUrl: this.apiUrl
//		});
//	},
	computed: {
		objectTypeDisplay () {
//			console.log(this.objectType)
			switch (this.objectType) {
				case 'apartment':
					return 'lägenheter';
				case 'premise':
					return 'lokaler';
				case 'district':
					return 'områden';
				default:
					return 'träffar';
			}
		},
	},
}
</script>
